import type { Theme } from '@material-ui/core/styles'
import { useMediaQuery as muiUseMediaQuery } from '@material-ui/core'
import { useTheme } from '@material-ui/styles'

export function useMediaQuery(
  mediaQuery: number | string | ((theme: Theme) => string) | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'print',
  options?: { up?: boolean; noSsr?: boolean }
) {
  const noSsr = options?.noSsr ?? true
  const up = options?.up ?? false

  const theme = useTheme<Theme>()
  const isPrint = muiUseMediaQuery('print', { noSsr })

  // If a function is passed (e.g. (theme) => theme.breakpoints.down('sm')),
  // resolve it and use directly with MUI's useMediaQuery
  if (typeof mediaQuery === 'function') {
    const resolved = mediaQuery(theme)
    return muiUseMediaQuery(resolved, { noSsr })
  }

  // If a raw CSS media query string is passed (e.g. from theme.breakpoints.down()),
  // use it directly with MUI's useMediaQuery
  if (typeof mediaQuery === 'string' && mediaQuery.startsWith('@media')) {
    return muiUseMediaQuery(mediaQuery, { noSsr })
  }

  const breakpointName = mediaQuery === 'print' ? 'lg' : mediaQuery

  const breakpoint = up ? theme.breakpoints.up(breakpointName as any) : theme.breakpoints.down(breakpointName as any)
  const queryResult = muiUseMediaQuery(breakpoint, { noSsr })

  if (mediaQuery === 'print') {
    return isPrint
  }

  return !isPrint && queryResult
}
